/**
 * Main Layout Component
 * 
 * This component provides the main application layout
 * with header, navigation, and content area.
 */

import React from 'react';
import { useApp } from '../../context/AppContext';
import Header from './Header';
import Navigation from './Navigation';
import MainContent from './MainContent';

const MainLayout = () => {
  const { state } = useApp();

  return (
    <div className={`app ${state.currentLanguage === 'ar' ? 'rtl' : 'ltr'}`}>
      <Header />
      <Navigation />
      <MainContent />
    </div>
  );
};

export default MainLayout;
